(function () {
  const MOBILE_QUERY = '(max-width: 749px)';
  const mql = window.matchMedia(MOBILE_QUERY);
  const COLLAPSED_LABEL = 'Add to bag';
  const EXPANDED_LABEL = 'Done';
  const BAG_ICON = `
    <svg class="sticky-atc-button__icon" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
      <path d="M6.5 8.5h11l-.75 10.25a2 2 0 0 1-2 1.85h-5.5a2 2 0 0 1-2-1.85L6.5 8.5Z" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/>
      <path d="M9 8.5V7a3 3 0 0 1 6 0v1.5" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
    </svg>
  `;

  class StickyAddToCart {
    constructor(productInfo) {
      this.productInfo = productInfo;
      this.section = productInfo.dataset.section;
      this.container = productInfo.querySelector('.product__info-container');
      this.stickyBoundary = productInfo.querySelector('.product__description');
      this.variantPicker = productInfo.querySelector('variant-selects');
      this.quantity = productInfo.querySelector(`#Quantity-Form-${this.section}`);
      this.form = productInfo.querySelector('product-form');
      this.submitButton = this.form?.querySelector('[type="submit"]');
      this.submitButtonText = this.submitButton?.querySelector('span');
      this.bar = null;
      this.active = false;
      this.expanded = false;
      this.scrollFrame = null;
      this.originalButtonLabel = this.submitButtonText?.textContent;
      this.placeholders = new Map();

      this.update = this.update.bind(this);
      this.recalc = this.recalc.bind(this);
      this.handleScroll = this.handleScroll.bind(this);
      this.handleSubmitClick = this.handleSubmitClick.bind(this);
      this.handleKeydown = this.handleKeydown.bind(this);

      mql.addEventListener('change', this.update);
      window.addEventListener('resize', this.recalc);
      window.addEventListener('orientationchange', this.recalc);
      window.addEventListener('scroll', this.handleScroll, { passive: true });

      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        subscribe(PUB_SUB_EVENTS.variantChange, () => {
          requestAnimationFrame(() => {
            this.refreshVariantPickerReference();
            this.syncButtonLabel();
            this.recalc();
          });
        });
        subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
          if (event?.source !== 'product-form') return;
          this.setExpanded(false);
        });
      }

      this.update();
    }

    createPlaceholder(el) {
      const placeholder = document.createElement('div');
      const styles = window.getComputedStyle(el);
      const rect = el.getBoundingClientRect();

      placeholder.className = 'sticky-atc-placeholder';
      placeholder.style.display = styles.display === 'inline' ? 'inline-block' : 'block';
      placeholder.style.height = `${rect.height}px`;
      placeholder.style.marginTop = styles.marginTop;
      placeholder.style.marginRight = styles.marginRight;
      placeholder.style.marginBottom = styles.marginBottom;
      placeholder.style.marginLeft = styles.marginLeft;

      el.parentNode.insertBefore(placeholder, el);
      this.placeholders.set(el, placeholder);
    }

    restore(el) {
      const placeholder = this.placeholders.get(el);
      if (placeholder && placeholder.parentNode) {
        placeholder.parentNode.insertBefore(el, placeholder);
        placeholder.remove();
      }
      this.placeholders.delete(el);
    }

    isBeforeStickyBoundary() {
      if (!this.stickyBoundary) {
        this.stickyBoundary = this.productInfo.querySelector('.product__description');
      }
      if (!this.stickyBoundary) return true;

      const boundaryBottom = this.stickyBoundary.getBoundingClientRect().bottom + window.scrollY;
      const viewportBottom = window.scrollY + window.innerHeight;
      return viewportBottom < boundaryBottom;
    }

    refreshVariantPickerReference() {
      if (!this.active) return;

      const currentVariantPicker = this.productInfo.querySelector('variant-selects');
      if (!currentVariantPicker || currentVariantPicker === this.variantPicker) {
        currentVariantPicker?.classList.add('sticky-atc-bar__variants');
        return;
      }

      const placeholder = this.placeholders.get(this.variantPicker);
      this.placeholders.delete(this.variantPicker);
      this.variantPicker = currentVariantPicker;
      this.variantPicker.classList.add('sticky-atc-bar__variants');

      if (placeholder) {
        this.placeholders.set(this.variantPicker, placeholder);
      }
    }

    enable() {
      if (this.active || !this.container || (!this.form && !this.quantity && !this.variantPicker)) return;
      this.active = true;

      this.bar = document.createElement('div');
      this.bar.className = 'sticky-atc-bar';

      const inner = document.createElement('div');
      inner.className = 'sticky-atc-bar__inner';
      this.bar.appendChild(inner);

      if (this.variantPicker) {
        this.createPlaceholder(this.variantPicker);
        this.variantPicker.classList.add('sticky-atc-bar__variants');
        inner.appendChild(this.variantPicker);
      }

      if (this.quantity) {
        this.createPlaceholder(this.quantity);
        this.quantity.classList.add('sticky-atc-bar__quantity');
        inner.appendChild(this.quantity);
      }

      if (this.form) {
        this.createPlaceholder(this.form);
        this.form.classList.add('sticky-atc-bar__form');
        inner.appendChild(this.form);
      }

      this.submitButton?.addEventListener('click', this.handleSubmitClick, true);
      this.bar.addEventListener('keydown', this.handleKeydown);

      // Keep the bar inside .product__info-container so it shares the sticky
      // scroll context and stays within <product-info> for variant updates.
      this.container.appendChild(this.bar);
      document.body.classList.add('sticky-atc-active');
      this.setExpanded(false);
      this.recalc();
    }

    disable() {
      if (!this.active) return;
      this.active = false;

      if (this.scrollFrame) {
        cancelAnimationFrame(this.scrollFrame);
        this.scrollFrame = null;
      }

      this.submitButton?.removeEventListener('click', this.handleSubmitClick, true);
      this.bar?.removeEventListener('keydown', this.handleKeydown);

      if (this.variantPicker) {
        this.variantPicker.classList.remove('sticky-atc-bar__variants');
        this.restore(this.variantPicker);
      }

      if (this.quantity) {
        this.quantity.classList.remove('sticky-atc-bar__quantity');
        this.restore(this.quantity);
      }

      if (this.form) {
        this.form.classList.remove('sticky-atc-bar__form');
        this.restore(this.form);
      }

      this.expanded = false;
      this.restoreOriginalButtonLabel();

      if (this.bar) this.bar.remove();
      this.bar = null;

      document.body.classList.remove('sticky-atc-active');
      document.body.style.removeProperty('--sticky-atc-height');
      document.body.style.removeProperty('padding-bottom');
    }

    isSubmitDisabled() {
      return this.submitButton?.hasAttribute('disabled') || this.submitButton?.getAttribute('aria-disabled') === 'true';
    }

    restoreOriginalButtonLabel() {
      if (this.submitButtonText && this.originalButtonLabel) {
        this.submitButtonText.textContent = this.originalButtonLabel;
      }
    }

    renderButtonLabel(label) {
      if (!this.submitButtonText) return;

      if (label === COLLAPSED_LABEL) {
        this.submitButtonText.innerHTML = `${BAG_ICON}<span>${COLLAPSED_LABEL}</span>`;
        return;
      }

      this.submitButtonText.textContent = label;
    }

    syncButtonLabel() {
      if (!this.active || !this.submitButtonText || this.submitButton?.hasAttribute('disabled')) return;
      this.renderButtonLabel(this.expanded ? EXPANDED_LABEL : COLLAPSED_LABEL);
    }

    setExpanded(expanded) {
      if (!this.active || !this.bar) return;
      this.expanded = expanded;
      this.bar.classList.toggle('is-expanded', expanded);
      this.bar.classList.toggle('is-collapsed', !expanded);
      this.syncButtonLabel();
      requestAnimationFrame(this.recalc);
    }

    handleSubmitClick(event) {
      if (!this.active || this.expanded || this.isSubmitDisabled()) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      this.setExpanded(true);
    }

    handleKeydown(event) {
      if (event.key === 'Escape' && this.expanded) {
        this.setExpanded(false);
        this.submitButton?.focus();
      }
    }

    handleScroll() {
      if (this.scrollFrame) return;

      this.scrollFrame = requestAnimationFrame(() => {
        this.scrollFrame = null;
        this.update();
      });
    }

    recalc() {
      if (!this.active || !this.bar) return;
      const height = this.bar.offsetHeight;
      document.body.style.setProperty('--sticky-atc-height', `${height}px`);
      // The bar is fixed, so reserve space to avoid hiding page content behind it.
      document.body.style.paddingBottom = `${height}px`;
    }

    update() {
      if (mql.matches && this.isBeforeStickyBoundary()) {
        this.enable();
      } else {
        this.disable();
      }
    }
  }

  function init() {
    document
      .querySelectorAll('product-info[id^="MainProduct-"]')
      .forEach((productInfo) => new StickyAddToCart(productInfo));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
